'use client'

import * as DialogPrimitive from '@radix-ui/react-dialog'
import { Button } from '@repo/ui/components/button'
import { cn } from '@repo/ui/lib/utils'
import { ComponentPropsWithoutRef } from 'react'

function Lightbox({ ...props }: ComponentPropsWithoutRef<typeof DialogPrimitive.Root>) {
  return <DialogPrimitive.Root data-slot='lightbox' {...props} />
}

function LightboxTrigger({ ...props }: ComponentPropsWithoutRef<typeof DialogPrimitive.Trigger>) {
  return <DialogPrimitive.Trigger data-slot='lightbox-trigger' {...props} />
}

function LightboxPortal({ ...props }: ComponentPropsWithoutRef<typeof DialogPrimitive.Portal>) {
  return <DialogPrimitive.Portal data-slot='lightbox-portal' {...props} />
}

function LightboxClose({ ...props }: ComponentPropsWithoutRef<typeof DialogPrimitive.Close>) {
  return <DialogPrimitive.Close data-slot='lightbox-close' {...props} />
}

function LightboxOverlay({ className, ...props }: ComponentPropsWithoutRef<typeof DialogPrimitive.Overlay>) {
  return (
    <DialogPrimitive.Overlay
      data-slot='lightbox-overlay'
      className={cn(
        'data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out data-[state=open]:fade-in fixed inset-0 z-50 grid place-items-center overflow-y-auto bg-white',
        className,
      )}
      {...props}
    />
  )
}

function LightboxContent({ className, children, ...props }: ComponentPropsWithoutRef<typeof DialogPrimitive.Content>) {
  return (
    <LightboxPortal data-slot='lightbox-portal'>
      <LightboxOverlay>
        <DialogPrimitive.Content
          data-slot='lightbox-content'
          className={cn(
            'data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out data-[state=open]:fade-in grid size-full gap-4 bg-white text-black duration-200',
            className,
          )}
          {...props}
        >
          {children}
          <DialogPrimitive.Close asChild={true}>
            <Button variant='navigationInverse' className='right-miista-page-padding top-miista-page-padding fixed'>
              Close
            </Button>
          </DialogPrimitive.Close>
        </DialogPrimitive.Content>
      </LightboxOverlay>
    </LightboxPortal>
  )
}

function LightboxHeader({ className, ...props }: ComponentPropsWithoutRef<'div'>) {
  return <div data-slot='lightbox-header' className={cn('sr-only', className)} {...props} />
}

function LightboxTitle({ className, ...props }: ComponentPropsWithoutRef<typeof DialogPrimitive.Title>) {
  return <DialogPrimitive.Title data-slot='lightbox-title' className={cn('uppercase', className)} {...props} />
}

function LightboxDescription({ className, ...props }: ComponentPropsWithoutRef<typeof DialogPrimitive.Description>) {
  return <DialogPrimitive.Description data-slot='lightbox-description' className={cn('text-sm', className)} {...props} />
}

export { Lightbox, LightboxClose, LightboxContent, LightboxDescription, LightboxHeader, LightboxOverlay, LightboxPortal, LightboxTitle, LightboxTrigger }
